<!-- breadcrumb -->
<nav aria-label="breadcrumb" class="our-fleets mx-5">
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item">
      <a routerLink="/" class="text-decoration-none ff-poppins-medium" style="color: #000">Home</a>
    </li>
    <li class="breadcrumb-item active ff-poppins-medium" aria-current="page" style="color: #000">
      Our Fleet
    </li>
  </ol>
</nav>
<!-- end breadcrumb -->
<h1 class="visually-hidden-focusable">Our Fleet</h1>
<div class="d-flex p-4 car-list">
  <!-- Filter Sidebar -->
  <div
    class="offcanvas-backdrop"
    *ngIf="isSidebarOpen && !isDesktop"
    (click)="sharedService.closeSidebar()"
    (keyup.enter)="sharedService.closeSidebar()"
  ></div>
  <aside class="filters offcanvas-sidebar py-4 px-3" [class.open]="isSidebarOpen || isDesktop">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="ff-poppins-semibold" style="color: rgba(53, 53, 53, 1)">
        <img src="/icons/ic_filters.svg" alt="filter icon" class="me-1" />
        Filters
      </h5>
      <button mat-button class="reset-btn" (click)="resetFilters()">Reset All</button>
    </div>
    <!-- <div class="mb-4">
      <div class="filter-label ff-montserrat-semibold mb-2">Car Name</div>
      <mat-chip-listbox [(ngModel)]="selectedName" (ngModelChange)="onNameChange($event)">
        <mat-chip-option *ngFor="let name of (name$ | async)" [value]="name">{{ name }}</mat-chip-option>
      </mat-chip-listbox>
    </div>
    <hr style="border-color: #c3c7ca;" /> -->
    <div class="mb-4">
      <div class="filter-label ff-montserrat-semibold mb-2">Make</div>
      <mat-chip-listbox [(ngModel)]="selectedMake" (ngModelChange)="onMakeChange($event)">
        <mat-chip-option *ngFor="let make of make$ | async; trackBy: trackByValue" [value]="make">{{
          make
        }}</mat-chip-option>
      </mat-chip-listbox>
    </div>
    <hr style="border-color: #c3c7ca" />
    <div class="mb-4">
      <div class="filter-label ff-montserrat-semibold mb-2">Transmission</div>
      <mat-chip-listbox
        [(ngModel)]="selectedTransmission"
        (ngModelChange)="onTransmissionChange($event)"
      >
        <mat-chip-option
          *ngFor="let t of transmission$ | async; trackBy: trackByValueTransmission"
          [value]="t"
          >{{ t }}</mat-chip-option
        >
      </mat-chip-listbox>
    </div>
    <hr style="border-color: #c3c7ca" />
    <div class="mb-4">
      <div class="filter-label ff-poppins-semibold mb-2">Car seats</div>
      <div class="d-flex flex-wrap gap-3">
        <mat-checkbox
          *ngFor="let seat of seats$ | async; trackBy: trackByValueSeats"
          [checked]="filtersPayload.seats && filtersPayload.seats.includes(seat)"
          (change)="onSeatSelectionChange(seat, $event)"
          class="seat-checkbox"
        >
          {{ seat }}
        </mat-checkbox>
      </div>
    </div>
    <hr style="border-color: #c3c7ca" />
    <div class="mb-4">
      <div class="filter-label ff-montserrat-semibold mb-2">Price Range</div>
      <div class="d-flex flex-column align-items-center px-2">
        <mat-slider min="0" max="9999" step="5" class="w-100" discrete (change)="onPriceChange()">
          <input
            [value]="vehicleFilters.min_price"
            matSliderStartThumb
            [(ngModel)]="vehicleFilters.min_price"
          />
          <input
            [value]="vehicleFilters.max_price"
            matSliderEndThumb
            [(ngModel)]="vehicleFilters.max_price"
          />
        </mat-slider>
        <div class="d-flex justify-content-between align-items-center w-100">
          <p class="m-0 ff-poppins-semibold" style="color: var(--secondary-color)">
            {{ vehicleFilters.min_price | number }}
            <span class="ff-poppins" style="color: var(--text-five-color)">&nbsp;QAR</span>
          </p>
          <p class="m-0 ff-poppins-semibold" style="color: var(--secondary-color)">
            {{ vehicleFilters.max_price | number }}
            <span class="ff-poppins" style="color: var(--text-five-color)">&nbsp;QAR</span>
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="col-12 mt-3 mb-4 mb-md-0">
      <button mat-raised-button class="btn-submit" (click)="getVehicles()">
        {{ "Apply Filters" | translate }}
      </button>
    </div> -->
  </aside>

  <!-- Main Content -->
  <main class="car-list-main flex-grow-1 ms-lg-4">
    <section class="w-100 d-flex flex-wrap justify-content-between align-items-center">
      <div class="input-field col-12 col-md-6 col-lg-8 mb-3 mb-md-0">
        <mat-form-field appearance="outline" class="search-input-field-fleet w-100">
          <mat-icon matPrefix style="color: #000">search</mat-icon>
          <mat-icon
            matSuffix
            class="cursor-pointer"
            style="color: #000"
            (click)="onSearchClear()"
            *ngIf="searchTerm"
            >clear</mat-icon
          >
          <input
            type="text"
            matInput
            placeholder="{{ 'Search' | translate }}"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
          />
        </mat-form-field>
      </div>
      <div class="d-flex align-items-center gap-2 input-field">
        <span
          class="m-0"
          style="color: var(--text-five-color); font-size: 20px; white-space: nowrap"
          >Sort by:</span
        >
        <mat-select [(ngModel)]="sortBy" (selectionChange)="getVehicles()">
          <mat-option class="ff-poppins" value="lowest">Low to High</mat-option>
          <mat-option class="ff-poppins" value="highest">High to Low</mat-option>
        </mat-select>
      </div>
      <button
        type="button"
        class="d-lg-none btn p-0"
        aria-label="Toggle filters"
        (click)="onToggleFilter()"
      >
        <img src="/icons/ic_filter_white.svg" alt="Filters" loading="lazy" />
      </button>
    </section>
    <div class="cars-container mt-3">
      <ng-container *ngIf="cars && cars.length > 0 && carRows && carRows.length > 0">
        <ng-container *ngFor="let row of carRows; let rowIndex = index; trackBy: trackByCarRows">
          <!-- Row of car cards -->
          <div class="car-row d-flex flex-wrap gap-3 mb-4">
            <div
              class="car-col"
              *ngFor="let car of row; trackBy: trackByCar"
              [class.selected]="selectedCar?.id === car.id"
            >
              <app-car-card
                [car]="car"
                [height]="444"
                (click)="onCarSelect(car, rowIndex)"
              ></app-car-card>
            </div>
          </div>

          <!-- Expandable section below each row -->
          <div
            *ngIf="selectedRow === rowIndex && selectedCar"
            class="detail-section mb-4"
            #detailSection
          >
            <app-car-detail-card
              [car]="selectedCar"
              [dateFilters]="carCardFilters"
              (closeCard)="onCloseCard()"
            ></app-car-detail-card>
          </div>
        </ng-container>
      </ng-container>

      <div *ngIf="!cars || cars.length === 0" class="text-center mt-5">
        <svg width="200" height="160" viewBox="0 0 24 24" fill="none">
          <path d="M4 16L5.5 12H18.5L20 16H4Z" fill="#ccc" />
          <path
            d="M6 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            fill="#999"
          />
          <path d="M5.5 12L7 8h10l1.5 4H5.5Z" stroke="#aaa" fill="none" />
        </svg>
        <h4 class="text-muted">No cars available at the moment.</h4>
        <p>Please check back later or contact support for more info.</p>
      </div>
    </div>
  </main>
</div>

<!-- FAQ Section -->
<section id="faqs" class="px-4 py-5 w-100">
  <div class="eyebrow d-flex align-items-center mb-3">
    <span class="rule me-2"></span>
    <span class="label ff-poppins-light">Any Question?</span>
  </div>

  <h2 class="title ff-poppins-semibold mb-4">Frequently Asked Questions</h2>
  <div class="row g-3">
    <!-- Left: FAQ Accordion -->
    <div class="col-lg-8">
      <div *ngFor="let faq of faqs; let i = index; trackBy: trackByCarFaqs" class="mb-3">
        <div class="card faq-card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="ff-poppins-semibold">
              {{ faq.question }}
            </h4>
            <button
              type="button"
              class="fs-4 btn p-0 btn-toggle"
              style="height: 42px; border: none"
              [attr.aria-expanded]="openedFaq === i"
              [attr.aria-controls]="'faq-panel-' + i"
              (click)="openedFaq = openedFaq === i ? -1 : i"
            >
              {{ openedFaq === i ? '–' : '+' }}
            </button>
          </div>
          <div
            class="card-body pt-2 pb-3 px-3 ff-poppins-medium"
            *ngIf="openedFaq === i"
            [attr.id]="'faq-panel-' + i"
          >
            {{ faq.answer }}
          </div>
        </div>
      </div>
    </div>
    <!-- Right: Contact Card -->
    <div class="col-lg-4">
      <div
        class="card p-4 d-flex flex-column align-items-center border-0"
        style="border-radius: 12px !important"
      >
        <div class="mt-5">
          <img src="/icons/ic_faq_chat.svg" alt="Chat Icon" loading="lazy" />
        </div>
        <h4 class="ff-poppins-semibold text-center mb-4">Do you have more questions?</h4>
        <p
          class="mb-4 ff-poppins-medium text-center"
          style="font-size: 18px; line-height: 1.8; color: var(--text-five-color)"
        >
          End-to-end payments and financial management in a single solution. Meet the right platform
          to help realize.
        </p>
        <a
          mat-raised-button
          class="btn-submit w-100 mb-3"
          href="mailto:{{ supportEmail }}?subject=Support%20Request&body=Hello%20team,"
        >
          Shoot a Direct Mail
        </a>
        <a
          mat-stroked-button
          class="btn-cancel w-100"
          style="text-decoration: none; border-color: #346da3 !important; color: #346da3 !important"
          href="https://wa.me/{{ supportPhone }}"
          target="_blank"
          rel="noopener"
        >
          WhatsApp
        </a>
      </div>
    </div>
  </div>
</section>
